export default __webpack_public_path__ + "static/media/itinerary1_800.4b1d076f.webp";